import styled from "styled-components";
import { Box, BoxProps, TableRow } from "@material-ui/core";
import { selectionBorder } from "styles/utils";
import { TableRowProps } from "@material-ui/core/TableRow/TableRow";
import { MaterialSpecTableRow } from "pages/MaterialSpecs/components";

export const PreviousMaterialVersionContainer = styled(Box)<BoxProps & { selected?: boolean }>`
    display: flex;
    position: relative;
    margin: ${({ theme }) => `${theme.spacing(1)} 0 ${theme.spacing(1)} 0`};
    align-items: center;

    ${({ selected, theme }) => selectionBorder(theme.shadows[4], selected, false)}
`;

export const PreviousMaterialVersionTableRow = styled(TableRow)<TableRowProps & { selected?: boolean }>`
    ${MaterialSpecTableRow};

    background-color: ${({ theme, selected }) => (selected ? theme.palette.secondary.light : "")};
    margin: ${({ theme }) => `${theme.spacing(1)} 0 ${theme.spacing(1)} 0`};
`;
